<!-- 无线到有线区别：1.class="OffLineStatus"改为RealtStatus
  2. let dataSource=ref('4');  改为1
3.去掉 电池电量报警 栏目
4.列表中传感器名称改为测点名称，注释换一换-->
<template>
  <div class="RealtStatus ">
    <div class="status">
      <el-menu
      :default-active="activeIndex"
      mode="horizontal"
      @select="handleSelect"
      text-color="#fff"
      active-text-color="#359186">
        <el-menu-item class="hItem" index="状态"> 状态 : </el-menu-item>
        <el-menu-item index="全部">全部(<span>{{allNum}}</span>)</el-menu-item>
<!--        <el-menu-item index="正常">正常(<span>{{norNum}}</span>)</el-menu-item>-->
        <!-- <el-menu-item index="数据不更新">数据不更新(<span>{{dataNum}}</span>)</el-menu-item> -->
        <el-menu-item index="时间戳不更新">时间戳不更新(<span>{{timeNoChangeNum}}</span>)</el-menu-item>
        <el-menu-item index="特征值不更新">特征值不更新(<span>{{valueNoChangeNum}}</span>)</el-menu-item>
<!--        <el-menu-item index="波形不更新">波形不更新(<span>{{waveNum}}</span>)</el-menu-item>-->
        <el-menu-item index="报警数据无波形">报警数据无波形(<span>{{alarmNum}}</span>)</el-menu-item>
<!--        <el-menu-item index="设备报警">设备报警(<span>{{equipNum}}</span>)</el-menu-item>-->
<!--        <el-menu-item index="节点异常">节点异常(<span>{{nodeNum}}</span>)</el-menu-item>-->
        <!-- <el-menu-item index="电池电量报警">电池电量报警(<span>{{batteryNum}}</span>)</el-menu-item> -->

      </el-menu>
      <!-- <el-button type="primary" size="small" @click="test" style="margin-right: 500px">測試</el-button> -->
      <el-button style="margin-right: 490px" type="primary"   size="small" >数据刷新时间：{{dataTableUpdataTime}}</el-button>

      <!--      <div style="color: red">{{timestampToTime(new Date().valueOf())}}</div>-->
      <el-button type="primary" size="small" @click="batchConfirm(selectedTableData)" :loading="confirmLoading" style="margin-right:390px">批量确认</el-button>
      <div v-if="showConfirm=='empty' "><el-button type="primary" size="small" @click="changeShowConfirm" style="margin-right:280px" >隐藏已确认</el-button></div>
      <div v-else><el-button type="primary" size="small" @click="changeShowConfirm" style="margin-right:280px" >显示已确认</el-button></div>
      <el-button type="primary" size="small" @click="outExcel" :loading="outExcelLoading" style="margin-right:190px">导出全部</el-button>
      <!-- <el-button type="primary" size="small" @click="outAllEquips" :loading="outExcelLoading" style="margin-right:590px">导出全部设备</el-button> -->
      <el-button type="primary" size="small" @click="outExcelSelected(tableData)" :loading="outExcelLoading" style="margin-right:100px">导出当前</el-button>
      <el-button type="primary" size="small" @click="outExcelSelected(selectedTableData)" :loading="outExcelLoading" >导出自定义</el-button>
    </div>
    <div class="search">
        <span class="wordFind">查找：</span>
        <el-input
        class="find"
        v-model="search"
        size="mini"
        placeholder="请输入关键字"
        @change='startSearch'
        ></el-input>
        <span class="wordPage">选择每页显示的行数：</span>
        <el-select v-model="value" class="page" size="mini" @change="getAllStateNumber()">
          <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
          </el-option>
        </el-select>
    </div>
    <div class="statusTable">
      <!-- el-tabel设置height就会出现滚动条且表头跟着滚动条移动 -->
      <el-table
        :data="filterTable "
        @selection-change="handleSelectionChange"
        height="100%">
        <el-table-column type="selection" width="55" />
        <el-table-column
            type="index"
            :index ="setMenuIndex"
            width="80px"
            label="序号"
        >

        </el-table-column>
        <el-table-column
        prop="groupName"
        label="公司"
        sortable>
        </el-table-column>
        <el-table-column
        prop="companyName"
        label="分公司"
        sortable>
        </el-table-column>
        <el-table-column
        prop="factoryName"
        label="车间"
        sortable>
        </el-table-column>
        <el-table-column
        prop="unitName"
        label="机组"
        sortable>
        </el-table-column>
        <el-table-column
        prop="equipmentName"
        label="设备名"
        sortable>
        </el-table-column>
        <!-- <el-table-column
        label="测点名称"
        width="150px"
        >
        <template #default="scope">
            <el-button @click="showSensorPoints(scope.$index, scope.row)"  type="text" >{{scope.row.sensorName}}</el-button>
          </template>
        </el-table-column> -->
        <el-table-column
        prop="pointName"
        label="测点名称"
        width="150px"
        sortable>
        </el-table-column>
        <el-table-column
            prop="value"
            label="特征值"
            width="150px">
        </el-table-column>
        <el-table-column
        prop="updateTime"
        label="特征值更新时间"
        width="180px"
        sortable>

        </el-table-column>
        <!-- <el-table-column
        prop="status"
        label="实时状态"
        width="150px"
        sortable> -->
          <!-- <template #default="scope">
            <el-tooltip
                class="box-item"
                effect="light"
                :key="scope.row.id"
                :enterable="false"
                :disabled="(scope.row.status.indexOf('报警数据无波形') === -1 || scope.row.note === '' || scope.row.note === null)"
                :content="scope.row.note"
                placement="top"
            > -->
            <!-- 换行显示方法 -->
            <!-- <template #content><div v-html="scope.row.note"></div></template>
              <span style="cursor: pointer;">{{ scope.row.status }}</span>
            </el-tooltip>

          </template> -->
        <el-table-column
        label="实时状态"
        width="150px"
        sortable>
        <template #default="scope">
            <el-button @click="showAlarmNoWavedialog(scope.$index, scope.row)"  type="text" >{{scope.row.status}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
        label="确认状态"
        width="70px">
        <template #default="scope">
          <div v-if="scope.row.isConfirm==0">
            <el-button @click="updateIsConfirm(scope.row)"  type="text" >未确认</el-button>
          </div>
          <div v-else>
            <el-button @click="updateIsConfirm(scope.row)"  type="text" style="color:green;">已确认</el-button>
          </div>
          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--        label="详细信息"-->
<!--        width="80px">-->
<!--        <template #default="scope" >-->
<!--          <el-button type="info" size="mini" @click="handleEdit(scope.$index, scope.row)"-->
<!--            >查看</el-button-->
<!--          >-->
<!--        </template>-->
<!--      </el-table-column>-->
      </el-table>
    </div>
    <el-pagination
      layout="prev, pager, next"
      :total="filterTablePageNum*10"
      @current-change="handleCurrentChange"
      :current-page="currentPage">
    </el-pagination>
    <!-- 报警数据无波形对话框 -->
  <el-dialog
    v-model="AlarmNoWavedialog"
    title="报警数据无波形详细信息"
    width="25%"
  >
  <!-- :before-close="handleClose" -->
    <!-- <span>This is a message</span> -->
    <div class="AlarmNoWavedialogBody">
    <p>公司名称：{{AlarmNoWavedialogContent.companyName}}</p><br>
    <p>分厂名称：{{AlarmNoWavedialogContent.factoryName}}</p><br>
    <p>设备名称：{{AlarmNoWavedialogContent.equipmentName}}</p><br>
    <p>设备Uuid：{{AlarmNoWavedialogContent.equipmentUuid}}</p><br>
    <p>测点名称：{{AlarmNoWavedialogContent.pointName}}</p><br>
    <p>测点Uuid：{{AlarmNoWavedialogContent.pointUuid}}</p><br>
    <br><hr><br>
    <p>无波形数据的报警时间列表如下</p>
    <br>
    </div>

    <el-input
    v-model="AlarmNoWavedialogtest"
    :autosize="{ minRows: 2, maxRows: 4 }"
    type="textarea"
    placeholder="Please input"
    />


    <template #footer>
      <span class="dialog-footer">
        <el-button @click="showAlarmWavePic(AlarmNoWavedialogContent)">查看趋势波形图</el-button>
        <el-button @click="AlarmNoWavedialog = false">关闭</el-button>
        <!-- <el-button type="primary" @click="dialogVisible = false"
          >Confirm</el-button
        > -->
      </span>
    </template>
  </el-dialog>
  <TrendGraph ref="trendg" v-model="showGraph" @DrawWave="DrawWave"></TrendGraph>
  <SensorPoints v-model="SensorPointsContent.flag" :SensorPointsContent="SensorPointsContent"></SensorPoints>
  </div>
</template>

<script>
import {ref, onBeforeMount ,onBeforeUnmount, computed,onMounted, watch,router,nextTick,h} from 'vue'
import { ElMessageBox, ElLoading ,ElMessage} from 'element-plus'
import {useStore} from 'vuex'
import {useRoute, useRouter} from 'vue-router'
import axios from 'axios'
import TrendGraph from '../components/charts/TrendGraph.vue'
import SensorPoints from '../components/charts/SensorPoints.vue'
import {export_json_to_excel} from "../components/ExportFiles/Export2Excel";
export default {
  name: 'RealtStatus ',
  components:{
    TrendGraph,
    SensorPoints
  },
  setup(props, ctx){
    // const controller_all = new AbortController();
    // const controller_trend = new AbortController();
    // const controller_wave = new AbortController();
    // const controller_state = new AbortController();
    // const controller_some = new AbortController();
    // const controller_updateIsConfirm = new AbortController();
    var CancelToken = axios.CancelToken;
    var source = CancelToken.source();
    let Requests=[0,0,0];
    let showConfirm=ref('empty');
    let showSensorPointsFlag=ref(false);
    let SensorPointsContent=ref({
      points:null,
      row:null,
      flag:false
    });
    let dataSource=ref('1');
    let showGraph=ref(false);
    let AlarmNoWavedialogtest=ref('');
    let AlarmNoWavedialogContent=ref({});
    let AlarmNoWavedialog=ref(false);
    let activeIndex = ref('全部');
    let tableData = ref([]);
    let selectedTableData = ref([]);
    let trendInfo = {};
    let tmpTableData = ref([]);
    let search = ref('');
    let value = ref(10);  //每页显示的行数。
    let totalNum = ref(0);
    let currentPage = ref(1);
    let outExcelLoading = ref(false);
    let confirmLoading = ref(false)
    let treeWidth = computed(() => {
      return store.state.contentWidth;
    })
    let dataTableUpdataTime = ref(new Date().getDate());
    let setMenuIndex =((index) => {     ///计算表格中的序号
      // console.log(value)
      return index+1+value.value*(currentPage.value-1)
    })
    let options = ref([
      {
        value: 10,
        label: 10
      },
      {
        value: 15,
        label: 15
      },
      {
        value: 25,
        label: 25
      },
      {
        value: 50,
        label: 50
      },
      {
        value: 100,
        label: 100
      }
    ])
    let formatJson = (filterVal, jsonData) => {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }

    let stateRes = {};
    let statusMapRowNum =( (statu) => {              ///此函数用于将所选中的状态从汉字转换成适应后端接口的字段数量
      if (statu == '全部') return allNum.value;
      if (statu == '报警数据无波形')   return alarmNum.value ;
      if (statu == '数据不更新') return dataNum.value ;
      if (statu == '时间戳不更新') return timeNoChangeNum.value ;
      if (statu == '特征值不更新') return valueNoChangeNum.value ;
      if (statu == '电池电量报警') return batteryNum.value ;
    });
    let router = useRouter();
    // let routerData =this.$router.resolve({
    //   path:'picture.html',
    //   query:{id:999},
    // })


    /**
     * 获取所有的异常数据
     * @type {getAllData}
     */
    let test=(()=>{
      let routerData =router.resolve({
      name:'NoWavePicture',
      query:{data:JSON.stringify(options)}
    })
      window.open(routerData.href,"报警数据无波形图谱分析")
    })
    let testOut=(()=>{
      console.log('--------myTest--------------');
    })
    const getAllData = (() => {
      // let url='/api1/data/rt/allSelected'
      let info = store.state.nodeData
      info.node[5] = search.value;       ///将查找框里的数据加入路径
      let url = '/api1/data/rt/allSelected';
      for(let i=0;i<5;i++){
        // url += '/'+info.node[i]
        url += '/'+encodeURIComponent(info.node[i]).replace('%2F', '%252f');
      }
      console.log('info.node',info.node);
      //区分无线和有线设备
      url+='/'+dataSource.value;
      //区分显示或隐藏已确认
      url+='/'+showConfirm.value;


      return axios.get(url+'/'+(search.value==''?'empty':search.value)).then( res => {
        // console.log('all', res)
        let data = res.data.data;
        console.log('data', data)
        return data
      })
    })
    let showAlarmNoWavedialog=((index, row)=>{
        // console.log(row.status);
        AlarmNoWavedialogContent.value=row;
        // console.log(row.status.indexOf("报警数据无波形"));
        if(row.status.indexOf('报警数据无') >= 0)
        {
            AlarmNoWavedialog.value=true;
            AlarmNoWavedialogtest.value=AlarmNoWavedialogContent.value.note;
            // AlarmNoWavedialogtest.value+='\n哈哈';
            console.log("!",AlarmNoWavedialogContent);
        }
    })
    const trendg=ref();
    let showAlarmWavePic=(AlarmNoWavedialogContent)=>{
      console.log("showAlarmWavePic",AlarmNoWavedialogContent);
      var startTime=AlarmNoWavedialogContent.startTime-2592000000;
      startTime=startTime+"";
      // var endTime="1679924856671";
      var endTime=AlarmNoWavedialogContent.startTime
      endTime=endTime+"";
      console.log("myTimes----------",startTime,endTime);
      // var startTime="1679320056671"
      var pointIdString=AlarmNoWavedialogContent.pointId.replace(/%2f/gi,"%252F");
      // var pointIdString="6A";
      // pointIdString=pointIdString.replace(/%2f/gi,"%252F");
      var equipmentUuid=AlarmNoWavedialogContent.equipmentUuid
      // var equipmentUuid="09d31d6177ed091a1c857270fc72fa66"
      var title=AlarmNoWavedialogContent.equipmentName+" "+AlarmNoWavedialogContent.pointName+" 历史趋势图"
      var title2=AlarmNoWavedialogContent.equipmentName+" "+AlarmNoWavedialogContent.pointName+" 历史波形图"
      let url="api2/trend/"+equipmentUuid
      +"/"+pointIdString
      +"/"+startTime
      +"/"+endTime+"/info";
      var dataX=[];
      var dataY=[];
      var trendTimes=[];
      var AlarmPoints=[];
      var AlarmTimes=[];
      var dataPoints={
        unit1:'unit1',
        unit2:'unit2',
        trendTimes:[],
        xIndex:0,
        trendTime:'0',
        equipmentUuid:"",
        pointIdString:"",
        title2:""
      }
      axios.get(url).then((res) => {
        console.log('res___Trend',res);
        trendInfo=res.data.data.trendInfo;
        if(trendInfo==null||trendInfo.length==0)
        {
          trendg.value.DrawGraphNull(title);
          // trendg.value.DrawGraphNull2(title2);
        }
        else
        {
          dataPoints.unit1=trendInfo[0].unit
          for(var i=0;i<trendInfo.length;i++)
          {
              dataX.push(timestampToTime(trendInfo[i].trendTime))
              trendTimes.push(trendInfo[i].trendTime)
              dataY.push(trendInfo[i].trendValue[0].all)
              if(trendInfo[i].smpNum>0)
              {
                AlarmPoints.push({ value:"",xAxis: i, yAxis: trendInfo[i].trendValue[0].all })
              }
              // if(i>=1)
              // {
              //   for(var j=0;j<AlarmTimes.length;j++)
              //   {
              //     if(AlarmTimes[j]>=trendInfo[i-1].trendTime && AlarmTimes[j]<=trendInfo[i].trendTime)
              //     {
              //       AlarmPoints.push({ value:"!",xAxis: i, yAxis: trendInfo[i].trendValue[0].all })
              //     }
              //   }
              // }
              // if(i==1)
              // {
              //   // for(var j=0;j<AlarmTimes.length;j++)
              //   // {
              //   //   if(AlarmTimes[j]>=trendInfo[i-1].trendTime && AlarmTimes[j]<=trendInfo[i].trendTime)
              //   //   {
              //       AlarmPoints.push({ value:"",xAxis: i, yAxis: trendInfo[i].trendValue[0].all })
              //   //   }
              //   // }
              // }

          }
          dataPoints.trendTimes=trendTimes;
          dataPoints.trendTime=trendInfo[0].trendTime;
          dataPoints.equipmentUuid=equipmentUuid;
          dataPoints.pointIdString=pointIdString;
          dataPoints.title2=title2;
          // DrawWave(equipmentUuid,pointIdString,"1679320389410",title2);
          console.log('trendInfo[0].trendTime',trendInfo[0].trendTime);
          DrawWave(dataPoints);
          nextTick(()=>{
          trendg.value.DrawGraph(dataX,dataY,title,AlarmPoints,dataPoints);
          })
        }


      })
      showGraph.value=true;
      // console.log('trendg.value',trendg.value);



    }
    let DrawWave=(params)=>{
      // var url2="api2/wave-spectrum/"
      //   +params.equipmentUuid
      //   +"/"+params.pointIdString
      //   +"/"+params.trendTime
      //   +"/16384/0/info"
      // axios.get(url2).then((res)=>{
      //   console.log('resWave---',res);
      //   if(res.data.data!=null && res.data.data.waveValue!=null)
      //   {
      //     var waveValue=res.data.data.waveValue;
      //     var dataX=waveValue.waveX;
      //     var dataY=waveValue.waveY;
      //     var dataPoints={
      //       unitx:waveValue.waveUnit.x,
      //       unity:waveValue.waveUnit.y,
      //       trendTime:params.trendTime
      //     }
      //     trendg.value.DrawGraph2(dataX,dataY,params.title2,dataPoints);
      //   }
      //   else
      //   {
      //     trendg.value.DrawGraphNull2(params.title2);
      //   }

      // })
    }
    let outExcel = () => {      ///导出excel
      // const loadingInstance = ElLoading.service({ fullscreen: true, text: '获取数据中', background: 'rgba(0, 0, 0, 0.7)' })
      outExcelLoading.value = true
      getAllData().then(list => {
        // console.log(data)
        // loadingInstance.close()
        outExcelLoading.value = false

        // 数据格式处理
        list = list.map(l => {
          l.updateTime = timestampToTime(new Date(l.startTime).valueOf())
          l.value = l.value+""+l.unit
          return l
        })
        list=sortList(list)
        console.log("List",list);
        // list.sort(compare("pointName"))
        const tHeader = [ '公司', '分公司', '车间', '机组', '设备名', '测点名称','特征值', '实时状态', '更新时间' ];
        const filterVal = [  'groupName', 'companyName', 'factoryName', 'unitName', 'equipmentName', 'pointName','value', 'status', 'updateTime' ];
        const data =  formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, '全部实时状态表  导出时间 :'+timestampToTime(new Date().valueOf()));

      });
    }
    let outAllEquips = () => {      ///导出excel
      // const loadingInstance = ElLoading.service({ fullscreen: true, text: '获取数据中', background: 'rgba(0, 0, 0, 0.7)' })
      outExcelLoading.value = true
      let url='/api2/equipment/getAll'
      axios.get(url).then(list => {
        // console.log(data)
        // // loadingInstance.close()
        outExcelLoading.value = false

        // 数据格式处理
        // list = list.map(l => {
        //   l.updateTime = timestampToTime(new Date(l.startTime).valueOf())
        //   return l
        // })
        // list=sortList(list)
        console.log("list.data.data",list.data.data);
        // list.sort(compare("pointName"))
        const tHeader = ['集团名', '公司名','分厂名','设备名', '设备Uuid' ];
        const filterVal = [  'groupName','companyName','factoryName','equipmentName', 'equipmentUuid'];
        const data =  formatJson(filterVal, list.data.data);
        export_json_to_excel(tHeader, data, '监测的所有设备表  导出时间 :'+timestampToTime(new Date().valueOf()));

      });
    }
    let outExcelSelected = (val) => {      ///导出excel
      // const loadingInstance = ElLoading.service({ fullscreen: true, text: '获取数据中', background: 'rgba(0, 0, 0, 0.7)' })

        const tHeader = [ '公司', '分公司', '车间', '机组', '设备名', '测点名称','特征值', '实时状态', '更新时间' ];
        const filterVal = [  'groupName', 'companyName', 'factoryName', 'unitName', 'equipmentName', 'pointName', 'value','status', 'updateTime' ];
        val=sortList(val);
        console.log('val',val);
        const data =  formatJson(filterVal, val);
        export_json_to_excel(tHeader, data, '筛选后实时状态表  导出时间 :'+timestampToTime(new Date().valueOf()));

      };
    let sortList = (list) => {
      list.sort(compare("pointName"))
      list.sort(compare("equipmentUuid"))
      list.sort(compare("unitName"))
      list.sort(compare("factoryName"))
      list.sort(compare("companyName"))
      list.sort(compare("groupName"))
      return list
    }
    var compare = function (prop) {
        return function (obj1, obj2) {
            var val1 = obj1[prop];
            var val2 = obj2[prop];
            if (val1 > val2) {
                return -1;
            } else if (val1 < val2) {
                return 1;
            } else {
                return 0;
            }
        }
    }



    let store = useStore();     ///使用vuex中的内容
    let timeControl = setInterval(()=>{   ///定时获取数据
      getTableData();
    },1000*60);
    watch(() => store.state.nodeLable, () => {
      console.log('点击了设备树');
      let items = tmpTableData.value;
      getTableData()

      return ;
      let items1;
      // console.log(activeIndex.value);
      if (activeIndex.value == '状态' || activeIndex.value == '全部') {
        items1 = items.filter((item) => {
          return Object.keys(item).some((key1) => {
            return item[key1] == store.state.nodeLable;
          })
        })
      } else {
        items1 = items.filter((item) => {
        return Object.keys(item).some((key1) => {
          return item[key1] == store.state.nodeLable;
        }) && Object.keys(item).some((key1) => {
          return item[key1] == activeIndex.value;
        })
      })
      }
      tableData.value = items1;
    })
    watch(() =>value,() =>{
      console.log('监听');
      tableData();

    })
    let startSearch=(()=>{
      console.log('searchValue',search.value);
      getAllStateNumber();
    })
    let handleSelect = (key, keyPath) => {
      console.log(key,keyPath);
      activeIndex.value = key;
      filterTablePageNum.value = statusMapRowNum(activeIndex.value)/value.value ;
      getTableData();
    }
    let timestampToTime = (timestamp) => {
      let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()) + '';
      let ms = (timestamp % 1000).toString()
      while (ms.length < 3) {
        ms = '0' + ms
      }
      return Y + M + D + h + m + s ;
    }
    let getAllStateNumber = (() =>{       ///获取状态的数量
      let info = store.state.nodeData
      info.node[5] = search.value;       ///将查找框里的数据加入路径
      let url = '/api1/data/rt/state';
      for(let i=0;i<5;i++){
        // url += '/'+info.node[i]
        url += '/'+encodeURIComponent(info.node[i]).replace('%2F', '%252f');
      }
      console.log('info.node',info.node);
      //区分无线和有线设备
      url+='/'+dataSource.value;
      //区分显示或隐藏已确认
      url+='/'+showConfirm.value;
      // source.cancel('取消上一次的请求.');
      //上一次请求没返回不发出下一次请求
      if(Requests[0]==0)
      {
        //标记为正在请求
        Requests[0]=1;
        // controller_state.abort();
        // controller_some.abort();
        axios.get( url+'/'+(search.value==''?'empty':search.value)
        ,{
          cancelToken: source.token
        }
        // )
        // .catch(function(thrown) {
        //   if (axios.isCancel(thrown)) {
        //     console.log('Request canceled', thrown.message);
        //   } else {
        //     // 处理错误
        //   }
        // }
        )
        .catch(err=>{
            console.log(err)
            //标记为请求结束
          Requests[0]=0;
        })
        .then((res) => {
          // console.log('请求的数据')
          //标记为请求结束
          Requests[0]=0;
          stateRes  = res.data.data;
          console.log('请求的数据',url,stateRes);
          dataNum.value = stateRes.dataNotChange;
          timeNoChangeNum.value= stateRes.timeNotChange;
          valueNoChangeNum.value =stateRes.valueNotChange;
          allNum.value = stateRes.all;
          batteryNum.value = stateRes.electricAlarm;
          // norNum.value = stateRes.normal;               ///更改状态数；
          // waveNum.value = stateRes.alarmDataNoWave
          alarmNum.value = stateRes.alarmDataNoWave;
          // allNum.value = timeNoChangeNum.value+valueNoChangeNum.value+batteryNum.value+alarmNum.value;
          filterTablePageNum.value = statusMapRowNum(activeIndex.value)/value.value ;

          url = '/api1/data/rt/some';
          for(let i=0;i<5;i++){
            // url += '/'+info.node[i]
            url += '/'+encodeURIComponent(info.node[i]).replace('%2F', '%252f');
          }
          url = url +'/'+(activeIndex.value == '全部'? 'all':activeIndex.value);
      //   /data/rt/some/{groupName}/{companyName}/{factoryName}/{unitName}/{equipmentUuid}/{state}/{keywords}/{pageSize}/{page}
          url = url+'/'+(search.value==""?"empty":search.value);
          url+= '/'+value.value;
          url += '/'+currentPage.value;
          url+='/'+dataSource.value
          //区分显示或隐藏已确认
          url+='/'+showConfirm.value;
  //   /data/rt/some/{groupName}/{companyName}/{factoryName}/{unitName}/{equipmentUuid}/{state}/{keywords}/{pageSize}/{page}/{dataSource}
          console.log(url);
          return axios.get(url)
        }).then( res => {
          console.log('获取到的数据',res);
          let data = res.data.data;
          // data['time'] =
          dataTableUpdataTime.value = timestampToTime( new Date());
          for(let i=0;i<data.length;i++){
            data[i].updateTime = timestampToTime(data[i].startTime)
            data[i].value =Number(data[i].value).toFixed(3)+ ' '+data[i].unit;
            // data[i].value += ' '+data[i].unit;
            //data[i].startTime=new Date(data[i].startTime);
            //data[i].startTime=data[i].startTime.split('T')[0]+' ' +data[i].startTime.split('T')[1].split('+')[0];
          }
          //   data.startTime = data.startTime.split('T')[0]+' ' +data.startTime.split('T')[1];
          //  console.log(data);
          tableData.value = data;
          tmpTableData.value = data;
          let items;
          if (store.state.nodeLable) {
            items = tableData.value.filter((item) => {
              return Object.keys(item).some((key) => {
                return item[key] == store.state.nodeLable;
              })
            })
            tableData.value = items;
          }
          totalNum.value = tableData.value.length;
        })
      }
      else
      {
        console.log('上一个请求未完成，不发出新请求');
      }
    })
    let getTableData = (() =>{      ///开始获取数据表
      getAllStateNumber();          ///首先从接口里更新状态的数量
      //filterTablePageNum.value =
    })
    let getTableDatalost = (() => {
      getAllStateNumber();
      return;
      axios.get('/api1/data/rt').then(res => {
        if (res.data.code == 200) {
          let data = res.data.data;
         // data['time'] =
          for(let i=0;i<data.length;i++){
            data[i].updateTime = timestampToTime(data[i].startTime+data[i].keepTime)
            data[i].value += ' '+data[i].unit;
            //data[i].startTime=new Date(data[i].startTime);
            //data[i].startTime=data[i].startTime.split('T')[0]+' ' +data[i].startTime.split('T')[1].split('+')[0];
          }
        //   data.startTime = data.startTime.split('T')[0]+' ' +data.startTime.split('T')[1];
        //  console.log(data);
          tableData.value = data;
          tmpTableData.value = data;
          // for (let item in data) {
          //   if (data[item]['status'] == '正常') {
          //     norNum.value++;
          //   } else if (data[item]['status'] == '数据不更新') {
          //     dataNum.value++;
          //   } else if (data[item]['status'] == '波形不更新') {
          //     waveNum.value++;
          //   } else if (data[item]['status'] == '报警数据无波形') {
          //     // console.log(data[item]);
          //     alarmNum.value++;
          //   } else if (data[item]['status'] == '设备报警') {
          //     equipNum.value++;
          //   } else if (data[item]['status'] == '节点异常') {
          //     nodeNum.value++;
          //   } else if (data[item]['status'] == '电池电量报警') {
          //     batteryNum.value++;
          //   }
          // }
          let items;
          if (store.state.nodeLable) {
            items = tableData.value.filter((item) => {
              return Object.keys(item).some((key) => {
                return item[key] == store.state.nodeLable;
              })
            })
            tableData.value = items;
          }
          totalNum.value = tableData.value.length;
          // allNum.value = data.length;
          // console.log('长度',tableData.value.length);
          // console.log(data);
        }
        handleSelect(activeIndex.value,1);
      })
    })
    let handleCurrentChange = ((val) => {       ///更改页码，跳转到对应的第val的页
      currentPage.value = val;
      getTableData()
    })
    //更新未确认/已确认的状态
    let updateIsConfirm = ((row) => {
    let val=row.id;
    let string='设备:'+row.equipmentName
    +'<br>测点:'+row.pointName
    +'<br>异常状态:'+row.status
    +'<br>时间:'+row.updateTime
    ElMessageBox({
      title: '更改确认状态',
      message: h('p', null, [
        h('p', null, '设备:'+row.equipmentName),
        h('p', null, '测点:'+row.pointName),
        h('p', null, '异常状态:'+row.status),
        h('p', null, '时间:'+row.updateTime),
      ]),
      showCancelButton: true,
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      beforeClose: (action, instance, done) => {
        if (action === 'confirm') {
          let url = '/api1/data/updateIsConfirm/';
          url+=val;
          console.log('row',row);
          let isConfirm=row.isConfirm==0?1:0;
          url+='/'+isConfirm;
          axios.get(url).then((res)=>{
            // console.log(res);
            if(res.data.code==200)
            {
              getTableData();
              ElMessage({
                message: '确认状态更新成功.',
                type: 'success',
              })
              done()
            }
            else
            {
              ElMessage({
                message: '确认状态更新失败！',
                type: 'warning',
              })
              done()
            }
          })

        } else {
          ElMessage({
            message: '取消更新确认状态.',
            type: 'info',
          })
          done()
        }
      },
    })

    // ElMessageBox.confirm(
    //   string,
    //   '更改标记状态',
    //   {
    //     dangerouslyUseHTMLString: true,
    //   },
    //   'Confirm',
    //   {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //   }
    // )
    // .then(() => {
    //   let url = '/api1/data/updateIsConfirm/';
    //   url+=val;
    //   console.log('row',row);
    //   let isConfirm=row.isConfirm==0?1:0;
    //   url+='/'+isConfirm;
    //   axios.get(url).then((res)=>{
    //     // console.log(res);
    //     if(res.data.code==200)
    //     {
    //       getTableData();
    //       ElMessage({
    //         message: '确认状态更新成功.',
    //         type: 'success',
    //       })
    //     }
    //     else
    //     {
    //       ElMessage({
    //         message: '确认状态更新失败！',
    //         type: 'warning',
    //       })
    //     }
    //   })
    // })
    // .catch(() => {
    //   ElMessage({
    //     type: 'info',
    //     message: '取消标记已确认',
    //   })
    // })

    })
    let handleEdit = ((index, row) => {
      row.NowStatus =(new Date().valueOf() -  new Date(row.startTime).valueOf());
      row.day= row.NowStatus/(1000*60*60*24);
      if(row.day <1) row.day='';
      row.NowStatus%=(1000*60*60*24);
      row.house = row.NowStatus/(1000*60*60);
      row.NowStatus%=(1000*60*60);
      row.min = row.NowStatus/(1000*(60));

      let message = '报警状态：' + row['status'] + '<br>' + '故障时间：' + row['startTime'] + '<br>' + '目前状态：已出故障 '+row.NowStatus+' <br> 邮件状态：已发送邮件到：123456@mail.com';
      if (row['status'] == '电池电量报警') {
        message = '电池状态：电池电量过低<br>低于报警限制：2021.12.31 12:33<br>电池电量：7%<br>邮件状态：已发送邮件到：123456@mail.com';
      }
      ElMessageBox.alert(message, '详细信息', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        callback: (action) => {
          // ElMessage({
          //   type: 'info',
          //   // message: `action: ${action}`,
          // })
        },
      })
    })
    let allNum = ref(stateRes.all);
    let norNum = ref(stateRes.normal);
    let dataNum =ref(stateRes.all);
    let timeNoChangeNum = ref(stateRes.timeNotChange)
    let valueNoChangeNum = ref(stateRes.valueNotChange)
    let waveNum = ref(stateRes.alarmDataNoWave);
    let alarmNum =  ref(stateRes.alarmDataNoWave);
    let equipNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return item['status'].search('设备报警') !=-1 && Object.keys(item).some((keys) => {
          if (!store.state.nodeLable) {
            return true;
          } else {
            return item[keys] == store.state.nodeLable;
          }
        }) && Object.keys(item).some((key1) => {
            if (!search) {
              return true;
            }
            return String(item[key1])
            .toLowerCase()
            .match(search.value);
          });
      }).length
    });
    let nodeNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return item['status'].search('节点异常')!=-1 && Object.keys(item).some((keys) => {
          if (!store.state.nodeLable) {
            return true;
          } else {
            return item[keys] == store.state.nodeLable;
          }
        }) && Object.keys(item).some((key1) => {
            if (!search) {
              return true;
            }
            return String(item[key1])
            .toLowerCase()
            .match(search.value);
          });
      }).length
    });
    let batteryNum = ref(0);
    let filterTable = computed(() => {
      let input = search.value && search.value.toLowerCase();
      let items = tableData.value;
      //区分有线和无线设备，过滤一下
      items=items.filter(function(item){
        return item.dataSource == dataSource.value;
      })
      let items1;
      if (input) {
        items1 = items.filter((item) => {
          return Object.keys(item).some((key1) => {
            return String(item[key1])
            .toLowerCase()
            .match(input);
          })
        })
      } else {
        items1 = items;
      }
      return items1;
    })
    let filterTablePageNum = ref(0);   ///获取活动状态的总页码数量；
    let handleSelectionChange =(val) =>{
      console.log('handleSelectionChange',val);
      selectedTableData.value=val;
    }
    let changeShowConfirm =() =>{
      console.log('showConfirm',showConfirm.value);
      if(showConfirm.value=='empty')
      {
        showConfirm.value=0;
      }else{
        showConfirm.value='empty';
      }
      getTableData();
      // showConfirm.value=!showConfirm.value;
    }
    let batchConfirm=(vals)=>{
      console.log('vals',vals);
      let url = '/api1/data/updateIsConfirm/';
      vals.forEach(element => {
        // url+=val;
        // console.log('row',row);
        let isConfirm=element.isConfirm==0?1:0;
        let tempUrl=url
        tempUrl+=element.id
        tempUrl+='/'+isConfirm;
        axios.get(tempUrl).then((res)=>{
          console.log(res,'res');
        });
      })
      getTableData();

    }
    let showSensorPoints=(index,row)=>{
        console.log('index',index,'row',row)
        let url='/api1/data/getSensorPoints/'
        url+=row.equipmentUuid+'/'
        url+=row.sensorName
        axios.get(url).then((res)=>{
          console.log(res,'res');
          SensorPointsContent.value.points=res.data.data;
          SensorPointsContent.value.row=row;
          SensorPointsContent.value.flag=true
        });
    }
    onBeforeUnmount(()=>{
      window.clearInterval(timeControl)
      source.cancel('取消上一次的请求.')
    })
    onMounted(() => {
      getTableData();
    })
    return {
      showSensorPointsFlag,
      SensorPointsContent,
      showSensorPoints,
      showAlarmWavePic,
      DrawWave,
      handleSelectionChange,
      changeShowConfirm,
      batchConfirm,
      showConfirm,
      selectedTableData,
      trendg,
      showGraph,
      AlarmNoWavedialogtest,
      AlarmNoWavedialogContent,
      AlarmNoWavedialog,
      timeControl,
      allNum,
      norNum,
      dataNum,
      waveNum,
      alarmNum,
      equipNum,
      nodeNum,
      batteryNum,
      timeNoChangeNum,
      valueNoChangeNum,
      activeIndex,
      tableData,
      search,
      options,
      value,
      totalNum,
      currentPage,
      outExcelLoading,
      filterTable,
      tmpTableData,
      dataTableUpdataTime,
      treeWidth,
      handleSelect,
      getTableData,
      handleCurrentChange,
      handleEdit,
      outExcel,
      outAllEquips,
      outExcelSelected,
      timestampToTime,
      getAllStateNumber,//临时，等待删除
      stateRes,
      filterTablePageNum,///表格的页码数量
      setMenuIndex,
      startSearch,
      showAlarmNoWavedialog,
      updateIsConfirm,
      confirmLoading,
      test,
      testOut
    }
  }
}
</script>

<style lang="scss">
  .RealtStatus {
    width: calc(100% - v-bind(treeWidth));
    margin-right: 10px;
    height: calc(100vh - 70px);
    margin-bottom: 10px;
    background-color: #303749;
    // background-color: #bfa;
    .el-dialog {
      background: #2c3242;
      .AlarmNoWavedialogBody{
        color: white;
        text-align: left;
      }
    }
    span.el-dialog__title {
    color: white;
    }
    textarea.el-textarea__inner {
    background-color: #2c3242;
    color: white;
    }
    .status{
      height: 10%;
      background-color: #2c3242;
      margin-left: 10px;
      margin-right: 10px;
      margin-top: 10px;
      .el-menu{
        height: 100%;
        background-color: #2c3242;
        border-bottom: 0px;
        display: flex;
        align-items: center; //垂直居中
        // justify-content: center;
        .el-menu-item.hItem{
          font-size: 20px;
        }
        .el-menu-item{
          color: #fff;
          font-size: 13px;
          border-bottom: 0px;
        }
        .el-menu-item.is-active{
          background-color: #2c3242 !important;
          color: #359186;
          border-bottom: 0px;
        }
        .el-menu-item.hItem.is-active{
          background-color: #2c3242 !important;
          color: #fff !important;
          border-bottom: 0px;
        }
        .el-menu-item:hover{
          background-color: #2c3242 ;
          color: #359186;
        }
        .el-menu-item.hItem:hover{
          background-color: #2c3242;
          color: #fff;
        }
      }
      .el-button:hover{
        border-color: #42b983;
        color: #42b983;
      }
      .el-button{
        background-color: #2C3242;
        border-color: #fff;
        position: absolute;
        margin-top: -50px;
        right: 30px;
      }
    }
    .search{
      display: flex;
      margin: 0px 10px;
      position: relative;
      align-items: center;
      span{
        margin-top: 10px;
        font-size: 13px;
        color: #fff;
      }
      span.wordFind{
        margin-left: 5px;
      }
      .el-input{
        // margin-left: 10px;
        margin-top: 10px;
        width: 200px;
        .el-input__inner{
          background-color: #303749;
          color: #fff;
          border: 1px #fff solid;
        }
      }
      .el-input .el-input__inner.active{
        border: 1px red solid;
      }
      .el-select .el-input{
        width: 100px;
        .el-input__inner{
          text-align: center;
          border: 1px #fff solid;
        }
        .el-input__suffix, .el-input__suffix-inner{
          margin-top: 0px;
        }
      }
      span.wordPage{
        position: absolute;
        right: 100px;
      }
      .el-select.page{
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
    .statusTable{
      margin-left: 10px;
      margin-right: 10px;
      background-color: #2c3242;
      height: 75%;
      //去除表格最下面那条线
      .el-table::before{
        height: 0px;
      }
      .el-table{
        background-color: #2c3242;
        //去除表头下面那条线
        th.el-table__cell.is-leaf{
          border-bottom: 0px;
        }
        //设置排序图标的颜色
        // .descending .sort-caret.descending {
        //   border-top-color: #359186;
        // }
        // .ascending .sort-caret.ascending {
        //   border-bottom-color: #359186;
        // }
        .cell{
          text-align: center;
        }
        th{
          background-color: #2c3242;
          color: #fff;
          // border-right: 1px solid rgba(256, 256, 256, 0.5);
        }
        tr{
          background-color: #2c3242;
          color: #fff;
          td{
            border-bottom: 0px;
          }
        }
        tr:hover td{
          background-color: rgba(107, 199, 255, 0.98) !important;
        }
      }
    }
    .el-pagination{
      margin-top: 10px;
      display: flex;
      align-items: center; //垂直居中
      ul li{
        background-color: #303749;
        color: #fff;
      }
      ul li.active{
        color: #359186;
      }
      ul li:hover{
        color: #359186;
      }
      .btn-prev{
        background-color: #303749;
        .el-icon{
          color: #fff;
        }
        .el-icon:hover{
          color: #359186;
        }
      }
      .btn-next{
        background-color: #303749;
        .el-icon{
          color: #fff;
        }
        .el-icon:hover{
          color: #359186;
        }
      }
    }
  }
</style>
